import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'dmg_packaging',
} as IModuleProps;
